import axios, { AxiosInstance } from "axios";
import { showLoadingToast, showFailToast } from "vant";
const service: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 50000, // 全局超时时间
});
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 展示加载中的toast
    showLoadingToast({ message: "加载中...", duration: 3 });
    return config;
  },
  (error) => {
    // 请求错误处理
    showFailToast("请求错误");
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (response.status >= 200 && response.status < 300) {
      const { data } = response;
      if (data && typeof data === "object" && "code" in data) {
        if (data.code === 200) {
          return response;
        } else {
          showFailToast("数据错误：" + (data.message || "未知错误"));
          return Promise.reject(data);
        }
      } else {
        return response;
      }
    } else {
      showFailToast("HTTP 状态码错误：" + response.status);
      return Promise.reject(response);
    }
  },
  (error) => {
    showFailToast("请求失败");
    return Promise.reject(error);
  }
);
export default service;
